class CustomTabs {
  constructor(container) {
    this.container = container;
    // Strict Data Attribute Selection
    this.nav = container.querySelector("[data-tab-nav]");
    this.triggers = container.querySelectorAll("[data-tab-trigger]");
    this.panes = container.querySelectorAll("[data-tab-content]");

    if (!this.nav || !this.triggers.length) return;

    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => this.handleTabClick(event));
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;

    // 1. Reset state
    this.triggers.forEach((tab) => {
      tab.classList.remove("is-active");
      tab.setAttribute("aria-selected", "false");
    });
    this.panes.forEach((pane) => {
      pane.classList.remove("is-active");
    });

    // 2. Set active state
    clickedTab.classList.add("is-active");
    clickedTab.setAttribute("aria-selected", "true");

    const targetId = clickedTab.getAttribute("aria-controls");
    // Select pane via ID, but ensure it is one of our data-tab-content elements
    const targetPane = this.container.querySelector(
      `[data-tab-content][id="${targetId}"]`,
    );
    if (targetPane) {
      targetPane.classList.add("is-active");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const tabContainers = document.querySelectorAll("[data-custom-tabs]");
  tabContainers.forEach((container) => new CustomTabs(container));
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.hasAttribute("data-custom-tabs")) {
      new CustomTabs(event.target);
    } else {
      const nestedTabs = event.target.querySelectorAll("[data-custom-tabs]");
      nestedTabs.forEach((container) => new CustomTabs(container));
    }
  });

  document.addEventListener("shopify:block:select", (event) => {
    const blockId = event.detail.blockId;
    const activeTabButton = document.querySelector(
      `[aria-controls="content-${blockId}"]`,
    );
    if (activeTabButton) {
      activeTabButton.click();
    }
  });
}
